import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import VideosModal from "../modal/VideosModal";
import VideoModulesEdit from "../admin/VideoModulesEdit";
import VideoItem from "./VideoItem";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  GetAwarenessModule,
  selectAwarenessModule,
} from "../../../features/learning/AwarenessSlice";
import { useParams } from "react-router-dom";
const title: String = "Videos";

const VideoList = () => {
  const dispatch = useAppDispatch();
  const params = useParams();
  const { categoryId }: any = params || "";

  const AwarenessModule = useAppSelector(selectAwarenessModule);
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);

  useEffect(() => {
    var data = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
      categoryId,
    };
    async function fetchLearningModuleData() {
      let sample = await dispatch(GetAwarenessModule(data));
    }
    fetchLearningModuleData();
  }, []);
  return (
    <>
      <Row className="bgwhite pl20 pr30">
        <Col xl={10} lg={10} md={9} sm={9} xs={6} style={{ marginTop: 10 }}>
          <h4 style={{ fontSize: "24px" }}>{title}</h4>
        </Col>

        <Col
          xl={2}
          lg={2}
          md={3}
          sm={3}
          xs={6}
          style={{ textAlign: "right", paddingRight: "0px" }}
          className="px-0"
        >
          <VideosModal records={AwarenessModule} />
          <VideoModulesEdit data={AwarenessModule} />
        </Col>
      </Row>
      <Row className="bgwhite p_all">
        <Col lg={12}>
          <Row>
            {AwarenessModule.length > 0 ? (
              AwarenessModule?.slice(0, 6).map((item: any) => {
                return <VideoItem item={item} columns={4} />;
              })
            ) : (
              <span style={styles.text1}>No records found</span>
            )}
          </Row>
        </Col>
      </Row>
    </>
  );
};

const styles: any = {
  text1: {
    fontFamily: "Georama-Regular",
    fontSize: "16px",
    fontWeight: "normal",
    border: "solid 1px #e4e4e4",
    borderTop: "0px",
    borderLeft: "0px",
    borderRight: "0px",
    color: "#6d6e71",
    textAlign: "center",
  },
};

export default VideoList;
